export const redirectUrl = "https://meetings.hubspot.com/vlad-lialine";
